// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-toggle-box{float:left}.react-toggle-text{display:inline-block;margin-left:10px;margin-top:3px;vertical-align:top}.react-toggle-track-x{display:none}", ""]);
// Exports
module.exports = exports;
